import { useState, useEffect } from 'react';
import { FieldRow } from '../../shared';

export interface ContactsData {
  contact_name: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  physical_address: string | null;
  contact_notes: string | null;
  qc_flag_contacts: boolean | null;
  qc_flag_contacts_notes: string | null;
}

export interface ContactsSectionProps {
  data: ContactsData;
  editable: boolean;
  onChange?: (updates: Partial<ContactsData>) => void;
}

/**
 * ContactsSection - Editable contacts form for QC Workflow
 */
export function ContactsSection({ data, editable, onChange }: ContactsSectionProps) {
  const [localData, setLocalData] = useState<ContactsData>(data);

  useEffect(() => {
    setLocalData(data);
  }, [data]);

  const handleFieldChange = (field: keyof ContactsData, value: string) => {
    const updates = { ...localData, [field]: value };
    setLocalData(updates);
    onChange?.(updates);
  };

  return (
    <>
      <FieldRow
        label="Contact Name"
        value={localData.contact_name}
        editable={editable}
        onChange={(v) => handleFieldChange('contact_name', v)}
      />
      <FieldRow
        label="Contact Email"
        value={localData.contact_email}
        editable={editable}
        onChange={(v) => handleFieldChange('contact_email', v)}
      />
      <FieldRow
        label="Contact Phone"
        value={localData.contact_phone}
        editable={editable}
        onChange={(v) => handleFieldChange('contact_phone', v)}
      />
      <FieldRow
        label="Physical Address"
        value={localData.physical_address}
        editable={editable}
        onChange={(v) => handleFieldChange('physical_address', v)}
        multiline
      />
      <FieldRow
        label="Contact Notes"
        value={localData.contact_notes}
        editable={editable}
        onChange={(v) => handleFieldChange('contact_notes', v)}
        multiline
      />
    </>
  );
}

export default ContactsSection;
